import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const safeNumber = (value) => Number(value || 0);

export const generateOutstandingInvoicesReportPDF = (reportData, formatCurrency) => {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const summary = reportData?.summary || {};
  const period = reportData?.period || {};
  const invoices = Array.isArray(reportData?.invoices) ? reportData.invoices : [];
  const customerSubtotals = Array.isArray(reportData?.customerSubtotals) ? reportData.customerSubtotals : [];

  const title = 'Outstanding Invoices Report';
  const periodLabel = String(period?.label || 'Current Year');

  doc.setFontSize(16);
  doc.text(title, 40, 40);
  doc.setFontSize(11);
  doc.text(`Period: ${periodLabel}`, 40, 60);

  autoTable(doc, {
    startY: 76,
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 6 },
    headStyles: { fillColor: [33, 37, 41] },
    head: [[
      'Total Outstanding',
      'Invoice Count',
      'Average/Invoice',
      'Total Amount',
      'Total Tax',
      'Total Received'
    ]],
    body: [[
      formatCurrency(safeNumber(summary.totalOutstanding)),
      String(safeNumber(summary.totalInvoices)),
      formatCurrency(safeNumber(summary.averagePerInvoice)),
      formatCurrency(safeNumber(summary.totalAmount)),
      formatCurrency(safeNumber(summary.totalTax)),
      formatCurrency(safeNumber(summary.totalReceived))
    ]]
  });

  const detailsStartY = (doc.lastAutoTable?.finalY || 100) + 20;
  doc.setFontSize(12);
  doc.text('Pending Invoices', 40, detailsStartY);

  autoTable(doc, {
    startY: detailsStartY + 8,
    theme: 'striped',
    styles: { fontSize: 9, cellPadding: 5 },
    headStyles: { fillColor: [53, 116, 224] },
    head: [[
      'Invoice Number',
      'Customer Name',
      'Date',
      'Amount',
      'Tax',
      'Received',
      'Pending'
    ]],
    body: invoices.map((invoice) => ([
      invoice.invoiceNumber || '-',
      invoice.customerName || 'Unknown Customer',
      invoice.date || '-',
      formatCurrency(safeNumber(invoice.amount)),
      formatCurrency(safeNumber(invoice.tax)),
      formatCurrency(safeNumber(invoice.received)),
      formatCurrency(safeNumber(invoice.pending))
    ]))
  });

  const subtotalStartY = (doc.lastAutoTable?.finalY || detailsStartY + 18) + 20;
  doc.setFontSize(12);
  doc.text('Customer Subtotals', 40, subtotalStartY);

  autoTable(doc, {
    startY: subtotalStartY + 8,
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 6 },
    headStyles: { fillColor: [108, 117, 125] },
    head: [['Customer Name', 'Invoice Count', 'Pending Total']],
    body: customerSubtotals.map((row) => ([
      row.customerName || 'Unknown Customer',
      String(safeNumber(row.invoiceCount)),
      formatCurrency(safeNumber(row.pendingAmount))
    ]))
  });

  const periodToken = periodLabel.replace(/\s+/g, '-');
  doc.save(`Outstanding-Invoices-${periodToken}.pdf`);
};
